var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 710,
    height: 666,
    viewBox: "0 0 710 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4647_9143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 607,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.621 607.329H194.021V665.604H493.621V607.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4647_9143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.688 660.934C414.857 660.934 472.55 603.222 472.55 532.03C472.55 460.838 414.857 403.125 343.688 403.125C272.52 403.125 214.827 460.838 214.827 532.03C214.827 603.222 272.52 660.934 343.688 660.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.021 605.248H493.622",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.132 24.19L25.4932 163.333C11.4137 176.693 10.8267 198.94 24.182 213.025L320.814 525.846C334.17 539.93 356.41 540.517 370.49 527.157L517.128 388.014C531.208 374.655 531.795 352.407 518.439 338.323L221.807 25.5017C208.452 11.4175 186.211 10.8302 172.132 24.19Z",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0057 138.265L149.79 81.5365C151.345 80.0611 153.801 80.1264 155.275 81.6814C156.75 83.2369 156.685 85.6939 155.13 87.1694L95.3471 143.897C93.792 145.372 91.3359 145.308 89.8609 143.752C88.3859 142.196 88.4513 139.739 90.0057 138.265Z",
    fill: "#343239",
    stroke: "#343239",
    strokeWidth: 2.68142
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.377 48.45L283.072 261.609C267.18 276.711 266.536 301.841 281.633 317.739L400.809 443.23C415.906 459.127 441.028 459.772 456.92 444.67L681.225 231.511C697.117 216.408 697.761 191.278 682.664 175.381L563.488 49.8896C548.391 33.9923 523.269 33.3478 507.377 48.45Z",
    fill: "#E4E2E2",
    stroke: "#343239",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M507.377 48.45L283.072 261.609C267.18 276.711 266.536 301.841 281.633 317.739L400.809 443.23C415.906 459.127 441.028 459.772 456.92 444.67L681.225 231.511C697.117 216.408 697.761 191.278 682.664 175.381L563.488 49.8896C548.391 33.9923 523.269 33.3478 507.377 48.45Z",
    fill: "#F7F3F3",
    stroke: "#343239",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.92 381.077L503.835 288.979",
    stroke: "#343239",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M426.667 401.863L491.275 340.464",
    stroke: "#343239",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M346.107 325.601L372.734 353.639C378.088 359.278 386.998 359.506 392.634 354.15L432.065 316.679C437.701 311.323 437.93 302.41 432.575 296.772L405.948 268.734C400.594 263.095 391.684 262.867 386.047 268.223L346.617 305.694C340.981 311.05 340.752 319.963 346.107 325.601Z",
    fill: "#E8E8E8",
    stroke: "#343239",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M359.13 296.501L402.452 342.122",
    stroke: "#343239",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.849 323.021L389.77 294.507L406.873 278.255",
    stroke: "#343239",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M416.849 323.021L406.019 311.616L423.118 295.364",
    stroke: "#343239",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.819 344.123L388.921 327.87",
    stroke: "#343239",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M355.564 327.012L372.666 310.759",
    stroke: "#343239",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M454.714 156.901L459.024 152.76C459.784 153.491 460.693 153.333 461.886 152.187C463.229 150.897 463.218 150.02 462.631 149.409C461.716 148.456 460.586 149.37 459.043 150.451C456.773 152.059 453.035 154.705 449.716 151.25C446.926 148.346 447.263 144.099 450.842 140.66C454.422 137.222 458.633 137.157 461.183 139.662L456.932 143.745C456.169 143.19 455.229 143.376 454.364 144.207C453.29 145.239 453.372 146.22 453.93 146.8C454.774 147.679 455.919 146.78 457.461 145.699C459.82 144.006 463.512 141.519 466.774 144.915C469.621 147.878 469.077 152.209 465.378 155.762C461.679 159.315 457.39 159.627 454.684 156.929L454.714 156.901Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M467.445 142.151L454.197 128.36L458.567 124.162L463.46 129.255L470.276 122.708L474.053 126.639L467.237 133.187L471.815 137.953C473.274 139.472 474.419 139.26 475.373 138.343C476.328 137.426 476.585 136.291 475.126 134.772L474.711 134.34L479.081 130.142L479.496 130.574C483.43 134.669 482.858 138.97 479.279 142.409C475.699 145.847 471.379 146.246 467.445 142.151V142.151Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M478.614 126.61C474.308 122.128 474.93 117.521 478.778 113.824C482.626 110.128 487.21 109.705 491.574 114.218L491.66 114.307L487.29 118.505L487.176 118.386C485.33 116.465 483.892 116.729 482.669 117.904C481.446 119.079 481.124 120.505 482.97 122.426L490.824 130.603L486.454 134.801L478.599 126.625L478.614 126.61Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M502.043 122.488L506.413 118.29C507.761 118.828 508.894 118.484 510.296 117.137C512.22 115.289 512.197 113.564 510.109 111.389L508.735 109.96C509.117 111.999 508.507 113.872 507.001 115.32C503.973 118.228 498.777 119.297 493.727 114.04L486.802 106.832L491.172 102.634L498.097 109.842C500.271 112.105 502.305 112.013 503.946 110.437C505.586 108.861 505.717 106.788 503.585 104.569L496.661 97.361L501.031 93.163L514.35 107.028C519.157 112.032 517.882 117.123 513.959 120.891C510.559 124.158 506.223 125.317 502.073 122.459L502.043 122.488Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M502.717 91.5439L507.4 87.045L520.377 94.1947L513.754 80.9413L518.333 76.5427L526.978 95.8716L521.683 100.958L502.717 91.5439V91.5439Z",
    fill: "#1A1A1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M525.228 83.721C521.036 79.3574 521.167 73.075 525.701 68.7194C530.235 64.3637 536.443 64.5568 540.635 68.9203L541.808 70.1415L530.95 80.5722C532.91 81.9255 534.922 81.4529 536.503 79.9341C537.756 78.7306 538.423 77.5742 538.246 76.2553L542.765 71.914C544.687 75.766 543.846 80.383 540.266 83.8217C535.717 88.1917 529.449 88.0559 525.258 83.6924L525.228 83.721ZM534.672 71.6991C532.749 70.6826 530.971 71.1598 529.449 72.6212C527.928 74.0827 527.408 75.8704 528.378 77.7454L534.672 71.6991Z",
    fill: "#1A1A1A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M436.562 189.772L444.706 181.949C448.479 178.324 448.619 172.319 444.985 168.536L432.224 155.252C430.473 160.027 430.809 164.228 434.169 171.367C437.891 179.303 438.101 184.657 436.577 189.787L436.562 189.772Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.59 155.679L415.793 167.972C412.019 171.597 411.879 177.602 415.513 181.384L424.855 191.109C428.74 185.63 428.66 181.068 427.34 174.29C425.541 165.193 425.591 162.11 428.59 155.679V155.679Z",
    fill: "#1A1A1A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M186.453 190.402L202.58 174.91C210.053 167.731 210.329 155.84 203.133 148.349L177.861 122.041C174.393 131.497 175.059 139.817 181.712 153.955C189.084 169.67 189.5 180.272 186.481 190.431L186.453 190.402Z",
    fill: "#1A1A1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.665 122.886L145.322 147.231C137.849 154.41 137.573 166.301 144.769 173.792L163.27 193.051C170.964 182.2 170.804 173.166 168.189 159.743C164.628 141.728 164.726 135.623 170.665 122.886V122.886Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessMobile);
export default __webpack_public_path__ + "static/media/businessMobile.05f185804ffdd37304a99a0cacee69c2.svg";
export { ForwardRef as ReactComponent };